/**
 * Sticky offsets + z-index ladder for admin tables that pin their <thead>
 * to the window (page scroll) rather than to an inner TableContainer.
 *
 * Mirrors the *shape* of the inspector's stickyOffsets module
 * (`frontend/src/components/shared/DataViewTable/stickyOffsets.ts`)
 * but stays admin-owned. The admin side has no fixed chrome above the
 * table (AdminLayout doesn't pin an app header at the top of the
 * viewport), so we only model the toolbar + group-header band; the
 * inspector's CHROME_OFFSET / CHROME_OFFSET_COLLAPSED have no analogue.
 *
 * Kept intentionally small so other admin tables can adopt it later
 * without re-deriving the math.
 */

/**
 * Sticky-stack z-index map for admin tables.
 *   10  Results / Export / Fullscreen toolbar (already sticky at top:0)
 *    8  Group header row (`groupHeaderData` band)
 *    7  Column header row
 *
 * The 3-step gap between layers leaves room for any later additions
 * (frozen-column header cell, overlay decoration) without re-tuning.
 */
export const Z_TOOLBAR = 10
export const Z_GROUP_HEADER = 8
export const Z_COLUMN_HEADER = 7

/**
 * Fallback toolbar height used until the ResizeObserver in
 * `useStickyTableHead` reports a real measurement. Picked to match the
 * BaseReportPage Results toolbar (~64px with py:2 padding). A wrong
 * initial value only manifests as a one-frame mis-position - the
 * observer fixes it on the next layout pass.
 */
export const DEFAULT_TOOLBAR_HEIGHT = 64
